import { cn } from '@utils/cn';
import type * as CSS from 'csstype';
import { type ComponentProps } from 'react';

const TimeLineTrackLine = ({
  width = 2,
  className,
  borderStyle = 'solid',
  ...props
}: ComponentProps<'div'> & {
  width?: number;
  borderStyle?: CSS.Properties['borderStyle'];
}) => {
  return (
    <div
      style={{
        paddingBlock: 0,
        left: -width / 2,
        borderStyle,
        borderLeftWidth: width,
      }}
      className={cn(
        `absolute bottom-0 m-0! h-full border-primary/20`,
        className,
      )}
      {...props}
    ></div>
  );
};

export { TimeLineTrackLine };
